import NurseryVisitFields from "./NurseryVisitFields";
import FarmPlantationFields from "./FarmPlantationFields";
import CommercialFields from "./CommercialFields";
import BulkPurchaseFields from "./BulkPurchaseFields";
import GenericSpaceFields from "./GenericSpaceFields";

export const EXTRA_FIELDS_BY_KEY = {
  nursery: NurseryVisitFields,
  farm: FarmPlantationFields,
  commercial: CommercialFields,
  bulk: BulkPurchaseFields,
  generic: GenericSpaceFields,
};
